import { Layout } from "components";
import { Select } from "theme";

import { Box, Grid2, MenuItem, useTheme } from "@mui/material";
import { styled } from "@mui/system";

import BookingSchedule from "../../components/Modules/BookingSchedule";
import BookingTable from "../../components/Modules/BookingTable";
import DateSelector from "../../components/Modules/DateSelector";
import Notifications from "../../components/Modules/Notifications/Notifications.tsx";
import UserInfo from "../../components/Modules/UserInfo";
import { useAuth } from "../../utils/context/Auth/AuthContext.tsx";
import { EBookingListView, EScheduleOptions, ViewOptionsConfig } from "../../utils/enums/EBookingListView.tsx";
import { useFilterSync } from "../../utils/hooks/useFiltersSync.ts";

const StyledWrapper = styled(Grid2)(({ theme }) => ({
  borderWidth: 1,
  borderStyle: "solid",
  borderColor: theme.palette.secondary.contrastText,
}));

const StyledUserSection = styled(Grid2)(({ theme }) => ({
  borderBottomWidth: 1,
  borderBottomStyle: "solid",
  borderBottomColor: theme.palette.secondary.contrastText,
  padding: theme.spacing(1.25, 2.25),
}));

const StyledViewWrapper = styled(Box)(({ theme }) => ({
  borderLeftWidth: 1,
  borderLeftStyle: "solid",
  borderLeftColor: theme.palette.secondary.contrastText,
}));

const BookingList = () => {
  const { user } = useAuth();
  const { palette } = useTheme();

  const { filters, updateFilters } = useFilterSync({
    storageKey: "bookingListViewFilters",
    initialState: {
      tableLayout: EScheduleOptions.DAY,
      view: EBookingListView.GRID,
      hall: "",
    },
  });

  return (
    <Layout>
      <StyledWrapper container>
        <Box width="335px">
          <StyledUserSection container justifyContent="space-between" alignItems="center">
            {user && <UserInfo />}

            <Select
              sx={{
                "& .MuiSelect-select": {
                  paddingTop: "5px",
                  paddingBottom: "5px",
                },
              }}
              MenuProps={{
                sx: {
                  "& .MuiPaper-root": {
                    background: palette.primary.main,
                  },
                },
              }}
              value={filters.view}
              onChange={(e) => updateFilters({ view: String(e.target.value) as EBookingListView })}
            >
              {ViewOptionsConfig.map((el) => {
                return (
                  <MenuItem key={el.value} value={el.value}>
                    {el.label}
                  </MenuItem>
                );
              })}
            </Select>
          </StyledUserSection>

          {filters.view !== EBookingListView.LIST && <Box>
            <DateSelector enableWeekSelection={filters.tableLayout === EScheduleOptions.WEEK} />
          </Box>}
          <Box mt={2}>
            <Notifications/>
          </Box>
        </Box>
        <StyledViewWrapper width="calc(100% - 335px)">
          {
            filters.view === EBookingListView.LIST &&
            <BookingTable />
          }
          {
            filters.view === EBookingListView.GRID &&
            <BookingSchedule tableLayout={filters.tableLayout} setTableLayout={value => updateFilters({
              tableLayout: value,
            })} hall={filters.hall} setHall={value => updateFilters({
              hall: value,
            })}/>
          }
        </StyledViewWrapper>
      </StyledWrapper>
    </Layout>
  );
};

export default BookingList;
